import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const AnalyticsStat = ({ number, subtitle, title }) => {
   return (
      <div
         className={classNames(
            'p-4 bg-blue-100/20 text-blue-100 border border-solid border-blue-100/20 rounded-2xl overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.3)]'
         )}>
         <div className="font-semibold">{title}</div>
         <div className="text-xs opacity-70">{subtitle}</div>
         <div className="text-2xl font-semibold tracking-tight">{number}</div>
      </div>
   )
}

AnalyticsStat.propTypes = {
   number: PropTypes.string.isRequired,
   subtitle: PropTypes.string.isRequired,
   title: PropTypes.string.isRequired
}

const AnalyticsFeature = ({ active }) => {
   const [visible, setVisible] = useState(false)

   useEffect(() => {
      if (active) {
         setTimeout(() => {
            setVisible(true)
         }, 200)
      } else {
         setVisible(false)
      }
   }, [active])
   return (
      <div className="w-full h-full">
         <div
            className={classNames(
               'absolute flex flex-col gap-4 -top-[10%] sm:top-[15%] left-[0%] sm:left-[15%] w-[100%] sm:w-[70%] transition-all duration-700 scale-[70%] sm:scale-100',
               visible ? 'translate-y-0' : 'translate-y-10'
            )}>
            <div className={classNames('transition-all duration-700', visible ? 'opacity-100' : 'opacity-0')}>
               <AnalyticsStat
                  number="184,380"
                  subtitle="Number of Users"
                  title="Community Members"
               />
            </div>
            <div
               className={classNames(
                  'p-2 bg-white rounded-2xl overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.3)] transition-all duration-700 delay-50',
                  visible ? 'translate-y-0 opacity-90' : 'translate-y-10 opacity-0'
               )}>
               <img
                  className="w-full"
                  src="/assets/custom/communities/images/features/analytics/1.png"
                  alt="Analytics"
               />
            </div>
            <div
               className={classNames(
                  'p-2 bg-white rounded-2xl overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.3)] transition-all duration-700 delay-100',
                  visible ? 'translate-y-0 opacity-50' : 'translate-y-10 opacity-0'
               )}>
               <img
                  className="w-full"
                  src="/assets/custom/communities/images/features/analytics/2.png"
                  alt="Analytics"
               />
            </div>
         </div>
      </div>
   )
}

AnalyticsFeature.propTypes = {
   active: PropTypes.bool.isRequired
}

export default AnalyticsFeature
